export const _01_basic_interactions_tooltip = `
<ul>
    <li class='shortcuts__item'>Basic interactions </li>
    <li class='shortcuts__item'>Visualising object elements  </li>
    <li class='shortcuts__item'>Selecting and deselecting </li>
    <li class='shortcuts__item'>Dragging with Shift (perpendicular) </li>
    <li class='shortcuts__item'>Undo / redo / refresh </li>
    <li class='shortcuts__item'>Pan, Zoom, View down axis </li>
</ul>`;

export const _02_edge_design_tooltip = `
<ul>
    <li class='shortcuts__item'>Adding vertices (edge fractions, multiple edges, around face, across from vertex) </li>
    <li class='shortcuts__item'>Adding edges (straight with shift, multiple edges, drawing) </li>
    <li class='shortcuts__item'>Carving </li>
    <li class='shortcuts__item'>Splitting faces </li>
    <li class='shortcuts__item'>Adding edges with crosshair </li>
    <li class='shortcuts__item'>Offsetting faces </li>
    <li class='shortcuts__item'>Tooltips, Help, Floating context toolbar  </li>
</ul>`;

export const _03_more_viewing_options_tooltip = `
<ul>
	<li class='shortcuts__item'>Viewing perpendicular to face </li>
	<li class='shortcuts__item'>Storing and retrieving viewpoints </li>
	<li class='shortcuts__item'>Coordinate axes and planes </li>
	<li class='shortcuts__item'>Displaying shadow plane, grid </li>
	<li class='shortcuts__item'>Displaying vertex coordinates (moving / selected / all) </li>
	<li class='shortcuts__item'>Setting face colors and materials </li>
	<li class='shortcuts__item'>Viewing triangulated mesh </li>
</ul>`;


export const _04_pop_outs_tooltip = `
<ul>
	<li class='shortcuts__item'>Pop-out </li>
    <li class='shortcuts__item'>Pop-in </li>
	<li class='shortcuts__item'>Pop-out-cut (thicken) </li>
	<li class='shortcuts__item'>Making holes through bodies </li>
	<li class='shortcuts__item'>Connecting bridges </li>
	<li class='shortcuts__item'>Shift-bridge for freeform bridge </li>
    <li class='shortcuts__item'>Stitch </li>
</ul>`;

export const _05_moving_tooltip = `
<ul>
	<li class='shortcuts__item'>Moving and rotating elements </li>
	<li class='shortcuts__item'>Global and local positioning </li>
	<li class='shortcuts__item'>Dragging multiple vertices, manipulator at vertex, repositioning manipulator, snapping to body </li>
	<li class='shortcuts__item'>Live scaling </li>
	<li class='shortcuts__item'>Scaling objects with precision </li>
	<li class='shortcuts__item'>Setting precise values </li>
	<li class='shortcuts__item'>Set vertex coordinates </li>
</ul>`;

export const _06_fixing_tooltip = `
<ul>
	<li class='shortcuts__item'>Fixing objects</li>
	<li class='shortcuts__item'>Unfixing objects</li>
	<li class='shortcuts__item'>Deleting edges or vertices   </li>
	<li class='shortcuts__item'>Making faces invisible and filling them </li>
	<li class='shortcuts__item'>Dissolving faces into one </li>
	<li class='shortcuts__item'>Dissolving to split body in two </li>
</ul>`;

export const _07_face_edge_shapes_tooltip = `
<ul>
	<li class='shortcuts__item'>Flattening faces and edges</li>
	<li class='shortcuts__item'>Making edges linear or collinear </li>
	<li class='shortcuts__item'>Making faces or edges circular </li>
	<li class='shortcuts__item'>Turning edges into circular arcs </li>
	<li class='shortcuts__item'>Making circles with precision </li>
	<li class='shortcuts__item'>Copying edges </li>
</ul>`;

export const _08_smoothness_tooltip = `
<ul>
	<li class='shortcuts__item'>Smooth edges, faces or areas</li>
	<li class='shortcuts__item'>Setting smoothen strength</li>
	<li class='shortcuts__item'>Smooth edges without moving vertices</li>
	<li class='shortcuts__item'>Removing edge smoothness</li>
	<li class='shortcuts__item'>Make edge tangent or perpendicular</li>
	<li class='shortcuts__item'>Copy tangent and lock tangent</li>
	<li class='shortcuts__item'>Tangency visualisation and curvature combs</li>
</ul>`;

export const _09_symmetry_tooltip = `
<ul>
	<li class='shortcuts__item'>Mirroring model </li>
	<li class='shortcuts__item'>Mirror planes </li>
	<li class='shortcuts__item'>Setting symmetry plane </li>
	<li class='shortcuts__item'>Forming and clering symmetry sets </li>
	<li class='shortcuts__item'>Mirror vs. Symmetry </li>
</ul>`;

export const _10_precision_tooltip = `
<ul>
	<li class='shortcuts__item'>Setting the dimensions of the initial block </li>
	<li class='shortcuts__item'>Setting the distance between two vertices </li>
	<li class='shortcuts__item'>Displaying and Setting Coordinates </li>
	<li class='shortcuts__item'>Using the Grid </li>
	<li class='shortcuts__item'>Adding vertices on fractions of an edge </li>
	<li class='shortcuts__item'>Adding a vertex across an existing one  </li>
</ul>`;

export const _11_multiple_bodies_tooltip = `
<ul>
	<li class='shortcuts__item'>Copying one body, or more at once </li>
	<li class='shortcuts__item'>Copied bodies are independent </li>
	<li class='shortcuts__item'>Merging two bodies into one </li>
	<li class='shortcuts__item'>Splitting a body in two </li>
	<li class='shortcuts__item'>Snapping one body onto another </li>
</ul>`;

export const _12_save_load_tooltip = `
<ul>
	<li class='shortcuts__item'>Phi: A connected Onshape App </li>
	<li class='shortcuts__item'>Save Phi model to Onshape or file </li>
	<li class='shortcuts__item'>Auto-saving </li>
	<li class='shortcuts__item'>Sending to Onshape Part Studio </li>
	<li class='shortcuts__item'>Exporting to STEP or STL </li>
	<li class='shortcuts__item'>Loading from Onshape Part Studio </li>
	<li class='shortcuts__item'>Load a saved Phi model </li>
</ul>`;

export const _13_references_tooltip = `
<ul>
	<li class='shortcuts__item'>Importing, hiding and editing reference objects </li>
	<li class='shortcuts__item'>Snapping onto reference object </li>
	<li class='shortcuts__item'>Convert reference faces to Phi faces </li>
	<li class='shortcuts__item'>Importing reference STL files </li>
	<li class='shortcuts__item'>Importing and editing reference sketches </li>
</ul>`;


export const _14_settings_tooltip = `
<ul>
    <li class='shortcuts__item'>Show or hide labels </li>
    <li class='shortcuts__item'>Disable tooltips </li>
    <li class='shortcuts__item'>Set workspace units </li>
    <li class='shortcuts__item'>Set coordinate decimals </li>
    <li class='shortcuts__item'>Inner side red </li>
    <li class='shortcuts__item'>Consistency checks </li>
    <li class='shortcuts__item'>Grid spacing </li>
    <li class='shortcuts__item'>Backgrounds and lighting </li>
    <li class='shortcuts__item'>Display triangles per face </li>
    <li class='shortcuts__item'>Reference model appearance </li>
    <li class='shortcuts__item'>Search, floating toolbar and feedback </li>
</ul>`;
